<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P39IXH/tc-custom/9781467446129.jpg?1728129215254" alt="This image is the cover for the book 1 and 2 Thessalonians, Two Horizons New Testament Commentary (THNTC)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">1 and 2 Thessalonians, Two Horizons New Testament Commentary (THNTC)
      </h1>
      <p class="bookDescription body article font2">
        <i>A distinctively theological interpretation of the Thessalonian letters</i><br/><br/> In this commentary Andy Johnson engages with the developing interpretive framework of missional hermeneutics to present a theological interpretation of 1 &amp; 2 Thessalonians that aims to help the church more fully participate in the life and mission of the triune God.<br/><br/> After a verse by-verse commentary, Johnson closely examines the theology of the two epistles, focusing especially on the topics of eschatology, holiness, and election in light of his missional reading of 1 and 2 Thessalonians. In his exegetical and theological analyses, Johnson considers canonical concerns, doctrinal commitments, ecclesial practices, proposals from contemporary systematic theology, and insights gleaned from the field of neuroscience regarding personal and community formation, all of which help to clarify and enrich readers' understanding of various passages.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andy Johnson
      </h2>
      
      <p class="authorDescription body article"><B>Andy Johnson</B>&#160;is professor of New Testament at Nazarene Theological Seminary, Kansas City, Missouri, and coeditor of&#160;<I>Holiness and Ecclesiology in the New Testament.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fdddb91e